import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';

function WhatsappColourSmall(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), React.createElement("g", {
    clipPath: "url(#clip0)"
  }, React.createElement("path", {
    fill: "#40C351",
    fillRule: "evenodd",
    d: "M11.362.09A10.017 10.017 0 005.92.873L5.903.85C2.696 2.34.061 5.604.003 9.728a9.993 9.993 0 001.622 5.727c.015.03.033.058.052.087.053.082.105.163.062.257l-.973 3.573 3.66-.945c.11-.045.206.016.3.075a.861.861 0 00.112.063c2.085 1.271 4.64 1.718 7.045 1.26a10.022 10.022 0 007.727-7.056 10.025 10.025 0 00-.15-6.013 9.98 9.98 0 00-3-4.387 9.832 9.832 0 00-5.098-2.28zM7.017 4.51c-.1-.224-.275-.48-.54-.485l.017-.019c-1.203-.072-1.681.383-2.227 1.567-.354.887-.343 1.913-.045 2.812.293.954.84 1.773 1.376 2.577l.12.18C7.462 13.594 9.88 15.72 13.423 16c1.372-.049 2.683-1.275 2.57-2.854.017-.212-.152-.346-.32-.425l-2.16-1.123-.004-.002c-.335-.151-.56-.252-.817.111-.3.44-.619.863-.956 1.27-.118.157-.32.175-.49.096-1.787-.66-3.268-2.042-4.133-3.856-.09-.145-.101-.346.011-.485.078-.103.161-.202.244-.302.253-.304.507-.61.634-.998.056-.176.01-.358-.057-.522-.137-.34-.265-.685-.393-1.03-.171-.458-.342-.917-.535-1.369z",
    clipRule: "evenodd"
  })));
}

export default WhatsappColourSmall;
//# sourceMappingURL=WhatsappColourSmall.js.map